/* ============
 * Axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, Axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */

import Vue from 'vue';
import Axios from 'axios';
import store from '@/store';
import router from '@/routes'

Axios.defaults.baseURL = process.env.VUE_APP_API_LOCATION;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.response.use(
  response => response,
  (error) => {
    console.log(router)
    if (error.response.status === 401) {
      if(router.history.current.meta.auth) {
        router.push('/home');
      }  
    } else if (error.response.status === 403) {
        alert('권한이 유효하지 않습니다.')
        router.push('/home');
    } else if(error.response.data.header) {
      alert(error.response.data.header.resultMessages)
    } else {
      alert('서버가 응답하지 않습니다.')
    }
    return Promise.reject(error);
  },
);

let workCount = 0;

Axios.interceptors.request.use(
  conf => {
      workCount ++
      if(workCount === 1) {
        store.commit('common/SHOW_SPINNER',true)
      }
      return conf;
  },
  error => {
      workCount --
      if(workCount === 0) {
        store.commit('common/SHOW_SPINNER',false)
      }  
      return Promise.reject(error);
  }
);
Axios.interceptors.response.use(
  response => {
    workCount --
    if(workCount === 0) {
      store.commit('common/SHOW_SPINNER',false)
    }  
    return response;
  },
  error => {
    workCount --
    if(workCount === 0) {
      store.commit('common/SHOW_SPINNER',false)
    }  
    return Promise.reject(error);
  }
);

// Bind Axios to Vue.
Vue.$http = Axios;
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return Axios;
  },
});
